import { Button, GeneralHeartFilledIcon, GeneralHeartUnfilledIcon } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

type TFavoriteButton = {
  favoriteCount?: number;
  isFavorite?: boolean;
  onClick?: () => void;
  hideFavoriteCount?: boolean;
  size?: number;
};

export const FavoriteButton = ({
  favoriteCount = 0,
  isFavorite,
  onClick,
  hideFavoriteCount = false,
  size = 16,
}: TFavoriteButton) => {
  const intl = useIntl();

  if (!onClick) return null;

  return (
    <Button
      className="border-none rounded-full !p-0"
      onClick={onClick}
      onClickCapture={(e: React.MouseEvent) => {
        e.preventDefault();
      }}
      aria-label={
        isFavorite
          ? intl.formatMessage({ defaultMessage: 'Saved', id: 'fsB/4p' })
          : intl.formatMessage({ defaultMessage: 'Click to save', id: 'q+y0s3' })
      }
      label={
        <div
          className={cn('flex items-center w-full py-2 px-2 h-full bg-white rounded-full gap-1', {
            'py-1': !hideFavoriteCount && favoriteCount > 0,
          })}>
          {!hideFavoriteCount && favoriteCount > 0 && (
            <span className="font-normal text-500">
              {favoriteCount > 999
                ? intl.formatMessage({ defaultMessage: '1K+', id: 'dAHibN' })
                : favoriteCount}
            </span>
          )}
          {isFavorite ? (
            <GeneralHeartFilledIcon
              fontSize={size}
              className={cn('!p-0', {
                'text-black': isFavorite,
              })}
            />
          ) : (
            <GeneralHeartUnfilledIcon
              fontSize={size}
              className={cn('!p-0', {
                'text-black': isFavorite,
              })}
            />
          )}
        </div>
      }
    />
  );
};
